import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectIsNotLastFloor = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('not_last_floor')(jsonQuery),
);
